module.exports = __webpack_public_path__ + "static/media/metlife.4b3acf26.png";